import React, { Fragment } from "react";
import { Image, LI, P, UL } from "../../../../../AbstractElements";
import { dynamicImage } from "../../../../../Utils";
import ContactEdit from "../../Common/ContactEdit";
import { RootState } from "../../../../../ReduxToolkit/Store";
import { useSelector } from "react-redux";

export default function GroupChatHeader() {
  const { selectedGroup } = useSelector((state: RootState) => state.chat);
  return (
    <div className="right-sidebar-title">
      <div className="common-space">
        <div className="chat-time group-chat">
          <UL className="simple-list flex-row">
            {selectedGroup.users.slice(0, 3).map((user: any, i: number) => (
              <Fragment key={user.id}>
                <LI>
                  <Image
                    className="img-fluid rounded-circle"
                    src={user.image || dynamicImage("avtar/3.jpg")}
                    alt={user.name}
                  />
                </LI>
              </Fragment>
            ))}
            {selectedGroup.users.length > 3 && (
              <LI>
                <div className="custom-name profile-count light-background">
                  <P className="f-w-500">+{selectedGroup.users.length - 3}</P>
                </div>
              </LI>
            )}
          </UL>
          <div>
            <span>{selectedGroup.groupName || "Group Chat"}</span>
            <P>{`${selectedGroup.users.length} Members`}</P>
          </div>
        </div>
        {/* <div className="d-flex gap-2">
          <div className="contact-edit chat-alert">
            <i className="icon-info-alt"></i>
          </div>
          <ContactEdit divClass="chat-alert" />
        </div> */}
      </div>
    </div>
  );
}
